/* Sprayo CRO — language toggle for the how-to-use video.
   Shows one language at a time and stops the other, so switching never leaves
   audio playing from a panel nobody can see. */

if (!customElements.get("sprayo-video-toggle")) {
  customElements.define(
    "sprayo-video-toggle",
    class SprayoVideoToggle extends HTMLElement {
      connectedCallback() {
        this.addEventListener("click", (event) => {
          const button = event.target.closest("[data-sprayo-lang]");
          if (button) this.select(button.dataset.sprayoLang);
        });
      }

      select(lang) {
        this.querySelectorAll("[data-sprayo-lang]").forEach((button) => {
          const active = button.dataset.sprayoLang === lang;
          button.classList.toggle("is-active", active);
          button.setAttribute("aria-pressed", String(active));
        });

        this.querySelectorAll("[data-sprayo-panel]").forEach((panel) => {
          const active = panel.dataset.sprayoPanel === lang;
          panel.hidden = !active;
          if (!active) this.stop(panel);
        });
      }

      stop(panel) {
        panel.querySelectorAll("video").forEach((video) => video.pause());
        // An iframe keeps playing while hidden; reloading its src is the only
        // way to stop it without the provider's JS API.
        panel.querySelectorAll("iframe").forEach((frame) => {
          frame.src = frame.src; // eslint-disable-line no-self-assign
        });
      }
    }
  );
}
